const API_PATH = {
  SEND_OTP: "auth/sendOtp",
  CONTACT: "common/contact",
  VERIFY_OTP: "auth/verifyOtp",
  RE_SEND_OTP: "auth/resendOtp",
};

export default API_PATH;
